import moment from "moment";
import React from "react";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

function ResellerDetailModal(props) {
  let item = props.item;
  return (
    <Modal isOpen={true}>
      <ModalHeader><h2>Thanks For Your Purchase!</h2></ModalHeader>
      <ModalBody>
        {/* //show reseller order detail  */}
        {/* order no, created_at, game_user_name,user_game_id,zone_id,item_name,note,order_no */}
        <div className="row">
          {/* <div className="col-12">
            <div className="form-group mb-0 d-flex">
              <label className="mb-0" style={{width: '160px'}}>Order No</label> 
              : &nbsp;&nbsp;&nbsp;<p className="mb-0">{item.order_no}</p>
            </div>
            <hr className="my-2" />
          </div> */}

          <div className="col-12">
            <div className="form-group mb-0 d-flex">
              <label className="mb-0" style={{width: '160px'}}>Payment Time</label> 
              : &nbsp;&nbsp;&nbsp;<p className="mb-0">{moment(item.created_at).format("YYYY-m-d h:m:s a")}</p>
            </div>
            <hr className="my-2" />
          </div>

          {/* <div className="col-12">
            <div className="form-group mb-0 d-flex">
              <label className="mb-0" style={{width: '160px'}}>Player Name</label> 
              : &nbsp;&nbsp;&nbsp;<p className="mb-0">{item.game_user_name}</p>
            </div>
            <hr className="my-2" />
          </div> */}

          <div className="col-12">
            <div className="form-group mb-0 d-flex">
              <label className="mb-0" style={{width: '160px'}}>User Game ID</label> 
              : &nbsp;&nbsp;&nbsp;<p className="mb-0">{item.user_game_id}</p>
            </div>
            <hr className="my-2" />
          </div>

          {/* <div className="col-12">
            <div className="form-group mb-0 d-flex">
              <label className="mb-0" style={{width: '160px'}}>Zone Id</label> 
              : &nbsp;&nbsp;&nbsp;<p className="mb-0">{item.zone_id}</p>
            </div>
            <hr className="my-2" />
          </div> */}

          <div className="col-12">
            <div className="form-group mb-0 d-flex">
              <label className="mb-0" style={{width: '160px'}}>Item Name</label> 
              : &nbsp;&nbsp;&nbsp;<p className="mb-0">{item?.game?.name} : {item.item_name} {item?.game?.unit_name}</p>
            </div>
            <hr className="my-2" />
          </div>
          <div className="col-12">
            <div className="form-group mb-0 d-flex">
              <label className="mb-0" style={{width: '160px'}}>Status</label> 
              : &nbsp;&nbsp;&nbsp;<p className="mb-0">{item.status}</p>
            </div>
            {/* <hr className="my-2" /> */}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <button className="btn btn-default" onClick={props.onClose}>
          Close
        </button>
      </ModalFooter>
    </Modal>
  );
}

export default ResellerDetailModal;
